import { inject, Injectable } from "@angular/core";

import { catchError, Observable, of } from "rxjs";

import { environment } from "@environments/environment";
import { RequestState, SentinelProfileResponse } from "@shared/models";
import { ApiCacheService } from "@shared/services/util/api-cache.service";
import { GlobalService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class SentinelProfileService {
  apiCacheService = inject(ApiCacheService);
  globalService = inject(GlobalService);

  private readonly _baseUrl = environment.myTripApiUrl;

  getSentinelProfile(forceRefresh: boolean): Observable<RequestState<SentinelProfileResponse>> {
    const currentDate = new Date().toISOString().split("T")[0];
    const config = {
      cacheId: `imax-sentinel-profile-${this.globalService.authedToken().apaempid}`,
      cacheValidMinutes: 100,
      url: `${this._baseUrl}/SentinelProfile/${currentDate}`,
      forceRefresh,
    };
    return this.apiCacheService.request<SentinelProfileResponse>(config).pipe(
      catchError((error) => {
        if (error.status === 500) {
          return of({} as RequestState<SentinelProfileResponse>);
        }
        return of({} as RequestState<SentinelProfileResponse>);
      })
    );
  }
}
